import type { components } from "@/shared/api";
import { DEFAULT_LOCALE, isLocale } from "@/shared/i18n";

type LocalizedName = components["schemas"]["LocalizedName"];

// Название из справочника на текущем языке интерфейса.
export const localizedName = (name: LocalizedName, locale: string): string =>
  name[isLocale(locale) ? locale : DEFAULT_LOCALE];
